import { type Project } from "@/lib/backend/api";
import { ProjectCardFeatured } from "./project-card.featured";

type ProjectCardCarouselProps = {
  projects: Project[];
};

export function ProjectCardCarousel({ projects }: ProjectCardCarouselProps) {
  return (
    <div className="flex gap-4 overflow-x-auto scroll-smooth pb-4 pt-2 [&::-webkit-scrollbar]:hidden">
      {projects.map((project) => (
        <div key={project.id} className="w-[200px] flex-none">
          <ProjectCardFeatured project={project} />
        </div>
      ))}
    </div>
  );
}
